/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BarChart } from "../models/http/charts/bar-chart/bar-chart.model";
import { LineChart } from "../models/http/charts/line-chart/line-chart.model";
import { PieChart } from "../models/http/charts/pie-chart/pie-chart.model";
import { AdvancedFilters } from "../models/http/dashboard/advanced-filters.model";
import { ChartResponse } from "../models/ui/charts.model";
import { DashboardComponentEmissionsHttpService } from "./http/dashboard-component-emissions-http.service";

@Injectable({
	providedIn: "root"
})
export class DashboardComponentEmissionsService {
	constructor(
		private _dashboardComponentEmissionsHttpService: DashboardComponentEmissionsHttpService
	) {}

	/**
	 * Retrieves the total CO2 emissions data for a line chart.
	 *
	 * @param filters - The AdvancedFilters request body.
	 * @returns An Observable that emits the line chart data for the total CO2 emissions.
	 */
	public getTotalCo2EmissionsForLineChart(
		filters: AdvancedFilters
	): Observable<ChartResponse<LineChart>> {
		return this._dashboardComponentEmissionsHttpService.getTotalCo2Emissions(filters);
	}

	/**
	 * Fetches the embodied emissions bar chart data.
	 *
	 * @param filters - The AdvancedFilters request body.
	 * @returns An Observable that emits the BarChart data.
	 */
	public getEmbodiedEmissionsBarChart(
		filters: AdvancedFilters
	): Observable<ChartResponse<BarChart>> {
		return this._dashboardComponentEmissionsHttpService.getTop10Emissions(filters);
	}

	/**
	 * Fetches the pie chart data for resource emissions.
	 *
	 * @param filters - The AdvancedFilters request body.
	 * @returns An Observable that emits the PieChart data.
	 */
	public getResourcesEmissionsPieChartData(
		filters: AdvancedFilters
	): Observable<ChartResponse<PieChart>> {
		return this._dashboardComponentEmissionsHttpService.getResourcesEmissions(filters);
	}
}
